import "antd/lib/avatar/style";
import _Avatar from "antd/lib/avatar";
import { jsx as _jsx } from "react/jsx-runtime";
import { getInitials } from 'constants/helpers';
import React, { useMemo } from 'react';

var UserAvatar = function UserAvatar(_ref) {
  var user = _ref.user,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 30 : _ref$size;
  var image = useMemo(function () {
    if (user.image && !user.image.includes('placeholder')) return user.image;else return null;
  }, [user.image]);
  return /*#__PURE__*/_jsx(_Avatar, {
    size: size,
    className: "shadow useAvatar",
    src: image,
    children: getInitials(user)
  });
};

export default UserAvatar;